module.exports = __webpack_public_path__ + "img/hacienda-room-2.1fc1c42c.jpg";